import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Timer as TimerIcon, Pause, CirclePlay } from "lucide-react";

interface TimerProps {
  showTimer: boolean;
  onShowTimerChange: (show: boolean) => void;
}

export const Timer = ({ showTimer, onShowTimerChange }: TimerProps) => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [intervalId, setIntervalId] = useState<number | null>(null);

  const startTimer = () => {
    if (!isRunning) {
      const id = window.setInterval(() => {
        setTime((prev) => prev + 1);
      }, 1000);
      setIntervalId(id);
      setIsRunning(true);
    }
  };

  const pauseTimer = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
      setIsRunning(false);
    }
  };

  const resetTimer = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
    setTime(0);
    setIsRunning(false);
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="flex items-center gap-2 text-stone-400">
      <Button
        variant="link"
        size="icon"
        onClick={isRunning ? pauseTimer : startTimer}
        className="h-4 w-4 p-0"
      >
        {isRunning ? (
          <Pause className="h-4 w-4 text-orange-500" />
        ) : (
          <CirclePlay className="h-4 w-4 text-orange-500" />
        )}
      </Button>
      <div className="text-sm font-medium w-8 text-center">{formatTime(time)}</div>
      <TimerIcon className="h-4 w-4" />
    </div>
  );
};